<script setup>
  import { ref, onMounted, useSlots, useTemplateRef } from 'vue'
  import { useMutationObserver } from '@vueuse/core'
  import Icon from "./icons/Icon.vue";

  const props = defineProps({
    classes: {
      type: String,
      default: "",
    }
  })

  const emit = defineEmits(['buttonClick']);

  const slots = useSlots();

  const labelContainer = useTemplateRef('label-container');
  const textOverflows = ref(false);

  const showBadge = !!slots.badge;

  const checkTextOverflow = () => {
    const element = labelContainer.value;

    if (!element) return false;

    return element.scrollWidth > element.clientWidth;
  }

  onMounted(() => {
    useMutationObserver(labelContainer, (mutations) => {
      if (mutations[0])
        textOverflows.value = checkTextOverflow();
    }, {
      attributes: true,
      childList: true,
      subtree: true,
      characterData: true
    })
  });  

</script>

<template>
  <button
    @click.prevent="emit('buttonClick')"
    class="jwx-map-menu-select"
    :class="props.classes"
  >
    <span class="jwx-map-menu-select__icon">
      <slot name="icon"></slot>
    </span>
    <p
      ref="label-container"
      class="jwx-map-menu-select__label"
      :data-overflow="textOverflows"
    >
      <slot name="label"></slot>
    </p>
    <p v-if="showBadge" class="jwx-map-menu-select__badge">
      <slot name="badge"></slot>
    </p>
    <Icon name="chevron-up-down" class="jwx-map-menu-select__menu-icon" />
  </button>
</template>